export enum BookingEventStatus {
	HOLDING = "HOLDING",
	SUCCESS = "SUCCESS",
	CANCELED = "CANCELED",
}
